import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const researchCardPostdocUpload = async (data) => {
  api.post(API_URL + "research-card-postdoc", data);
};

export const getResearchCardPostdoc = async (rcp_id) => {
  return api
    .get(API_URL + `research-card-postdoc/${rcp_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResearchCardPostdocMentor = async (mentor_id) => {
  return api
    .get(API_URL + `research-card-postdoc/mentor/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getResearchCardPostdocAdmin = async () => {
  return api
    .get(API_URL + `research-card-postdoc/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const updateResearchCardPostdoc = (rcp_id, status) => {
  return api.put(`${API_URL}research-card-postdoc/${rcp_id}/${status}`);
};
